import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, errMsg } from '../lib/api';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const COUNTRIES = [['IN', 'India'], ['US', 'United States'], ['AE', 'UAE'], ['GB', 'United Kingdom'], ['SG', 'Singapore'], ['SA', 'Saudi Arabia'], ['AU', 'Australia'], ['CA', 'Canada'], ['EU', 'EU (other)']];

export default function Signup() {
  const nav = useNavigate();
  const [f, setF] = useState({ school_name: '', admin_name: '', email: '', password: '', country: 'IN' });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post('/auth/register-school', f);
      toast.success(`Welcome to ONRID, ${f.school_name}!`);
      window.location.href = '/';
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 noise-bg bg-slate-50" data-testid="signup-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-8">
        <img src="/brand/onrid-banner-transparent.png" alt="ONRID" className="h-12 w-auto object-contain mb-6" />
        <h1 className="font-display text-2xl font-extrabold tracking-tight mb-1">Create your school account</h1>
        <p className="text-sm text-slate-500 mb-6">Your school gets its own isolated workspace. You become its first admin.</p>
        <form onSubmit={submit} className="space-y-3">
          <Input data-testid="signup-school-name" placeholder="School name" value={f.school_name} onChange={(e) => setF({ ...f, school_name: e.target.value })} />
          <Input data-testid="signup-admin-name" placeholder="Your full name" value={f.admin_name} onChange={(e) => setF({ ...f, admin_name: e.target.value })} />
          <Input data-testid="signup-email" type="email" placeholder="Work email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
          <Input data-testid="signup-password" type="password" placeholder="Password (8+ chars, letters & numbers)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
          <select data-testid="signup-country" value={f.country} onChange={(e) => setF({ ...f, country: e.target.value })} className="w-full border border-slate-200 rounded-md px-3 py-2 text-sm bg-white">
            {COUNTRIES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          <Button data-testid="signup-submit" type="submit" disabled={busy || !f.school_name || !f.email || !f.password} className="w-full bg-orange-600 hover:bg-orange-500">{busy ? 'Creating...' : 'Create school account'}</Button>
        </form>
        <button data-testid="signup-back-login" onClick={() => nav('/login')} className="mt-4 text-xs text-slate-500 underline hover:text-slate-900">Already have an account? Sign in</button>
      </div>
    </div>
  );
}
